import React from "react";
import { useStateValue } from "./../StateProvider";
import Details from "./productDetails";
// import SubTotal from "../SubTotal";
// import ProductCart from "../ProductCart";

// import "./checkout.scss";

const ProductDetails = () => {
  const [{ detail, user }] = useStateValue();

  return (
    <div className="section product_Details">
      <div className="container">
        
              {detail.map((item) => (
                    <Details
                    id={item.id}
                    title={item.title}
                    image={item.image}
                    rating={item.rating}
                    price={item.price}
                  />
                
                //   <ProductCart
                //     id={item.id}
                //     title={item.title}
                //     image={item.image}
                //     rating={item.rating}
                //     price={item.price}
                //   />
                
              ))}

      </div>
    </div>
  );
};

export default ProductDetails;
